<template>
  <v-card>
    <v-card-title class="subtitle-1 py-2">{{ title }}</v-card-title>
    <div class="d-flex flex-row justify-space-around pt-0">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click.prevent="tab = 'all'">
            <v-icon
              :color="tab == 'all' ? 'primary' : 'grey lighten-1'"
              size="18"
              >mdi-tag</v-icon
            >
          </v-btn>
        </template>
        <span>Todas</span>
      </v-tooltip>
      <v-tooltip top v-if="personItems.length > 0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click.prevent="tab = 'face'">
            <v-icon
              :color="tab == 'face' ? 'primary' : 'grey lighten-1'"
              size="18"
              >face</v-icon
            >
          </v-btn>
        </template>
        <span>Persona</span>
      </v-tooltip>
      <v-tooltip top v-if="organizationItems.length > 0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            @click.prevent="tab = 'apartment'"
          >
            <v-icon
              :color="tab == 'apartment' ? 'primary' : 'grey lighten-1'"
              size="18"
              >apartment</v-icon
            >
          </v-btn>
        </template>
        <span>Organización</span>
      </v-tooltip>
      <v-tooltip top v-if="locationItems.length > 0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            @click.prevent="tab = 'location'"
          >
            <v-icon
              :color="tab == 'location' ? 'primary' : 'grey lighten-1'"
              size="18"
              >location_on</v-icon
            >
          </v-btn>
        </template>
        <span>Lugar</span>
      </v-tooltip>
      <v-tooltip top v-if="hashtagItems.length > 0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click.prevent="tab = 'pound'">
            <v-icon
              :color="tab == 'pound' ? 'primary' : 'grey lighten-1'"
              size="18"
              >mdi-pound</v-icon
            >
          </v-btn>
        </template>
        <span>Hashtag</span>
      </v-tooltip>
      <v-tooltip top v-if="mentionItems.length > 0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click.prevent="tab = 'at'">
            <v-icon
              :color="tab == 'at' ? 'primary' : 'grey lighten-1'"
              size="18"
              >mdi-at</v-icon
            >
          </v-btn>
        </template>
        <span>Mención</span>
      </v-tooltip>
    </div>
    <v-list
      class="pt-0"
      style="max-height: 25vh; overflow-y: scroll"
      v-if="tab == 'all'"
      dense
    >
      <v-list-item-group v-model="item" color="primary">
        <v-list-item v-for="(item, i) in items" :key="i">
          <v-list-item-content @click="filter(item)" class="py-0">
            <div class="d-flex justify-space-between">
              <span class="caption">{{ item.text }}</span>
              <span class="caption">{{ item.freq }}</span>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-list
      class="pt-0"
      style="max-height: 25vh; overflow-y: scroll"
      v-if="tab == 'face'"
      dense
    >
      <v-list-item-group v-model="item" color="primary">
        <v-list-item v-for="(item, i) in personItems" :key="i">
          <v-list-item-content @click="filter(item)" class="py-0">
            <div class="d-flex justify-space-between">
              <span class="caption">{{ item.text }}</span>
              <span class="caption">{{ item.freq }}</span>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-list
      class="pt-0"
      style="max-height: 25vh; overflow-y: scroll"
      v-if="tab == 'apartment'"
      dense
    >
      <v-list-item-group v-model="item" color="primary">
        <v-list-item v-for="(item, i) in organizationItems" :key="i">
          <v-list-item-content @click="filter(item)" class="py-0">
            <div class="d-flex justify-space-between">
              <span class="caption">{{ item.text }}</span>
              <span class="caption">{{ item.freq }}</span>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-list
      class="pt-0"
      style="max-height: 25vh; overflow-y: scroll"
      v-if="tab == 'location'"
      dense
    >
      <v-list-item-group v-model="item" color="primary">
        <v-list-item v-for="(item, i) in locationItems" :key="i">
          <v-list-item-content @click="filter(item)" class="py-0">
            <div class="d-flex justify-space-between">
              <span class="caption">{{ item.text }}</span>
              <span class="caption">{{ item.freq }}</span>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-list
      class="pt-0"
      style="max-height: 25vh; overflow-y: scroll"
      v-if="tab == 'pound'"
      dense
    >
      <v-list-item-group v-model="item" color="primary">
        <v-list-item v-for="(item, i) in hashtagItems" :key="i">
          <v-list-item-content @click="filter(item)" class="py-0">
            <div class="d-flex justify-space-between">
              <span class="caption">{{ item.text }}</span>
              <span class="caption">{{ item.freq }}</span>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-list
      class="pt-0"
      style="max-height: 25vh; overflow-y: scroll"
      v-if="tab == 'at'"
      dense
    >
      <v-list-item-group v-model="item" color="primary">
        <v-list-item v-for="(item, i) in mentionItems" :key="i">
          <v-list-item-content @click="filter(item)" class="py-0">
            <div class="d-flex justify-space-between">
              <span class="caption">{{ item.text }}</span>
              <span class="caption">{{ item.freq }}</span>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      tab: "all",
      item: "",
    };
  },
  props: {
    title: {
      type: String,
      default: "Filtros",
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    filter(filter) {
      this.$emit("filter", [{ source: "label", ...filter }]);
    },
  },
  computed: {
    personItems() {
      return this.items.filter((item) => item.type == "PER");
    },
    organizationItems() {
      return this.items.filter((item) => item.type == "ORG");
    },
    locationItems() {
      return this.items.filter((item) => item.type == "LOC");
    },
    hashtagItems() {
      return this.items.filter((item) => item.type == "HASHTAG");
    },
    mentionItems() {
      return this.items.filter((item) => item.type == "MENTION");
    },
  },
};
</script>

<style scoped>
.v-list-item {
  min-height: 26px !important;
}
</style>